<template>
  <main id="main-content" class="flex-display-body container py-5">
    <div class="row">
      <div class="col-12">
        <h1 class="display-4 pb-3">Not Found</h1>
        <p>Redirecting to <a href="/">homepage</a> in {{ timeout }} seconds.</p>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  title: 'Not Found',
  data() {
    return { timeout: 3 };
  },
  mounted() {
    setTimeout(() => window.location.assign('/'), this.timeout * 1000);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue